module.exports = __webpack_public_path__ + "static/media/Devil.8f5bbe0a.png";